<template>
  <div class="items">
    <div class="item_body_keyword">
      {{ item.keyword }}
    </div>
    <div class="item_body_name">
      {{ item.operatorUserName !== null ? item.operatorUserName : '' }}
    </div>
    <div class="item_body_date">
      {{ item.executionDate | dateText('YYYY.MM.DD') }}
    </div>
    <div class="item_body_button">
      <Button
        variant="main"
        size="w120"
        fsize="f12"
        @click="taskCompleteModalOpen"
      >
        タスクを完了する
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  components: {
    Button
  },

  methods: {
    taskCompleteModalOpen() {
      this.$emit('taskCompleteModalOpen', this.item);
    }
  }
};
</script>
